export default "__VITE_ASSET__DGy7XHgG__"